import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Casino from './pages/Casino';
import CasinoArea from './pages/CasinoArea';
import Hotel from './pages/Hotel';
import HotelArea from './pages/HotelArea';
import Dining from './pages/Dining';
import DiningArea from './pages/DiningArea';
import Golf from './pages/Golf';
import GolfArea from './pages/GolfArea';
import Spa from './pages/Spa';
import Beach from './pages/Beach';
import Tennis from './pages/Tennis';
import Theatre from './pages/Theatre';
import GasStation from './pages/GasStation';
import Conference from './pages/Conference';
import Engagement from './pages/Engagement';
import Connection from './pages/Connection';
import Solution from './pages/Solution';
import AboutUs from './pages/AboutUs';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        {/* Casino */}
        <Route path="casino" element={<Casino />} />
        <Route path="casino/casino-floor" element={<CasinoArea area="casino-floor" />} />
        <Route path="casino/poker-room"   element={<CasinoArea area="poker-room" />} />
        <Route path="casino/sportsbook"   element={<CasinoArea area="sportsbook" />} />

        {/* Hotel */}
        <Route path="hotel"          element={<Hotel />} />
        <Route path="hotel/lobby"    element={<HotelArea area="lobby" />} />
        <Route path="hotel/pool"     element={<HotelArea area="pool" />} />
        <Route path="hotel/grab-n-go" element={<HotelArea area="grab-n-go" />} />
        <Route path="hotel/gifts"    element={<HotelArea area="gifts" />} />
        <Route path="hotel/office"   element={<HotelArea area="office" />} />
        <Route path="hotel/valet"    element={<HotelArea area="valet" />} />
        <Route path="hotel/shipping" element={<HotelArea area="shipping" />} />
        <Route path="hotel/guest"    element={<HotelArea area="guest" />} />

        {/* Dining */}
        <Route path="dining"                    element={<Dining />} />
        <Route path="dining/restaurant"         element={<DiningArea area="restaurant" />} />
        <Route path="dining/kitchen"            element={<DiningArea area="kitchen" />} />
        <Route path="dining/casual"             element={<DiningArea area="casual" />} />
        <Route path="dining/buffet"             element={<DiningArea area="buffet" />} />
        <Route path="dining/food-court"         element={<DiningArea area="food-court" />} />
        <Route path="dining/employee-dining"    element={<DiningArea area="employee-dining" />} />
        <Route path="dining/food-trucks"        element={<DiningArea area="food-trucks" />} />

        {/* Golf */}
        <Route path="golf"          element={<Golf />} />
        <Route path="golf/cart"     element={<GolfArea area="cart" />} />
        <Route path="golf/hall"     element={<GolfArea area="hall" />} />
        <Route path="golf/lounge"   element={<GolfArea area="lounge" />} />
        <Route path="golf/shop"     element={<GolfArea area="shop" />} />

        {/* Venue pages */}
        <Route path="spa"          element={<Spa />} />
        <Route path="beach"        element={<Beach />} />
        <Route path="tennis"       element={<Tennis />} />
        <Route path="theatre"      element={<Theatre />} />
        <Route path="gas-station"  element={<GasStation />} />
        <Route path="conference"   element={<Conference />} />
        <Route path="engagement"   element={<Engagement />} />
        <Route path="connection"   element={<Connection />} />

        {/* Solution detail */}
        <Route path="solutions/:id" element={<Solution />} />

        {/* About */}
        <Route path="aboutus"           element={<AboutUs />} />
        <Route path="aboutus/agilysys"  element={<AboutUs />} />
      </Route>
    </Routes>
  );
}

export default App;
